/*
 * Copyright, AlpineReplay, Inc. 2022. All rights reserved.
 * Author: Drew Burnett
 */

// Create Quick Save Forwarding Url

const createQuickSaveForwardingUrl = (
    gameTime,
    location,
    createUrl,
    saveUrl,
    insideMoment = true
) => {
    let forwardingUrl = ""
    let currentPathname = location.pathname
    // Let's create and/or save the highlight
    const relevantUrl = insideMoment ? saveUrl : createUrl
    if (!currentPathname.endsWith("/")) currentPathname += "/"
    if (location && currentPathname.includes("time/")) {
        forwardingUrl = currentPathname.replace(
            /\/time.*$/gi,
            `/${relevantUrl}`
        )
    } else {
        forwardingUrl = currentPathname + relevantUrl
    }
    // Add the full game time if necessary
    if (gameTime !== 0) {
        if (!forwardingUrl.endsWith("/")) forwardingUrl += "/"
        forwardingUrl += `start=${gameTime}`
    }
    console.log("forwardingUrl", forwardingUrl, insideMoment)
    return forwardingUrl
}

export { createQuickSaveForwardingUrl }
